import React from 'react';
import { H5, Card, Elevation } from '@blueprintjs/core';

import View, { TView } from '../layout/View';

export interface IWidget {
  positionVertical?: string;
  positionHorizontal?: string;
  label?: { title?: string };
  background?: boolean;
  hidden?: boolean;
  view?: TView;
}

const WidgetLabel: React.FC<{ label?: { title?: string } }> = ({ label }) => {
  if (!label) return null;

  const { title, ...props } = label;

  return (
    <H5 style={{ textAlign: 'center' }} {...props}>
      {title}
    </H5>
  );
};

const Widget: React.FC<{
  widget: IWidget;
  id: string;
  widgets?: import('../layout/View').DynamicObject<IWidget>;
  bareContent?: boolean;
}> = ({ widget, id, widgets, bareContent = false }) => {
  // If bareContent is true, render just the view without any wrapper or styling
  if (bareContent) {
    return widget.view ? <View view={widget.view} widgets={widgets} /> : null;
  }

  const style = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  } as const;

  const layout = () => (
    <React.Fragment>
      <WidgetLabel label={widget.label} />
      {widget.view && <View view={widget.view} widgets={widgets} />}
    </React.Fragment>
  );

  if (widget.background) {
    return (
      <Card elevation={Elevation.TWO} style={{ ...style, minWidth: '200px' }} id={id}>
        {layout()}
      </Card>
    );
  } else {
    return <div style={style}>{layout()}</div>;
  }
};

export default Widget;
